import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useParams } from "@tanstack/react-router";
// Server State
import { useCreditNoteCard } from "../../state/creditNoteCardState";
// Component imports
import CreditNoteLines from "./CreditNoteLines";
import CreditNoteDetails from "./CreditNoteDetails";
import { CreditNoteHeader } from "./CreditNoteHeader";
// MUI imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function CreditNoteCard() {
  const { id } = useParams({ strict: false });

  // Credit Note Details
  const [creditNote, setCreditNote] = useState({
    filter: {},
    crmemo: {},
  });

  const { isPending, isError, isSuccess, error, data } = useCreditNoteCard(id);

  // Success Function
  const successFunc = () => {
    setCreditNote(data.data.data.data.data);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      {isError && <Typography>Error: {error.message}</Typography>}
      <Box>
        <Box>
          <CreditNoteHeader no={creditNote.crmemo?.no} />
          <Box sx={{ pt: 1 }}>
            <CreditNoteDetails creditNote={creditNote.crmemo} />
          </Box>
        </Box>
      </Box>
      <Box>
        {creditNote.crmemo.line ? (
          <Box sx={{ pt: 1 }}>
            <CreditNoteLines
              creditNoteLines={creditNote.crmemo?.line}
              currencyCode={creditNote.crmemo?.currencyCode}
            />
          </Box>
        ) : (
          !isPending && <Typography>No Data</Typography>
        )}
      </Box>
    </>
  );
}
